<template>
  <div class="app-container">
    <list ref="list" :is-show="isShow" :can-price="canPrice">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
    <!--    <el-button type="info" @click="onPrintTemaplate">打印模板</el-button>  -->
        <el-button type="primary" plain @click="reviewAll">批量审核</el-button>
        <el-button type="danger" plain @click="backAll">批量弃审</el-button>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" :width="isShow ? 160 : 80">
          <template slot-scope="{ row }">
            <!-- <el-button v-if="$permission.canWrite() && isShow" type="text" @click="edit(row)">编辑</el-button>
            <el-button v-if="$permission.canWrite() && isShow" type="text" @click="edit(row)">审核</el-button> -->
            <template v-if="row.Status < 2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="edit(row)">编辑</el-button>
              </template>
            </template>
            <el-button type="text" v-else @click.stop="details(row)">查看</el-button>
            <el-button type="text" @click.stop="print(row)">打印</el-button>
            <el-button v-if="!isShow" type="text" @click="select(row)">选择</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog" @close-saved="reload" /> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/business/purchase/stock/list";
// import editDialog from "@/components/business/purchase/stock/editDialog";

export default {
  name: "rank",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog,
  },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice();
    },
  },
  methods: {
    // path:"/business/purchase/stock"
    onPrint2(row) {
      var url = location.origin + "/#/customprintview/进货单/" + row.DocId;
      window.open(url, "_blank");
    },

     print(row) {
      let newpage = this.$router.resolve({
        path: '/stockPrint2?id=' + row.DocId
      })
      window.open(newpage.href, '_blank');
    },
    onPrintTemaplate() {
      var url = location.origin + "/#/customprint/" + "进货单";
      window.open(url, "_blank");
    },
    create() {
      this.$router.push({ name: "editStock", params: { mode: "create" } });
    },
    edit(data) {
      this.$router.push({
        name: "editStock",
        params: { mode: "edit", data },
      });
    },
    editById(id) {
      this.$router.push({
        name: "editStock",
        params: { mode: "editById", rowId: id },
      });
    },
    details(data) {
      this.$router.push({
        name: "editStock",
        params: { mode: "details", data },
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DocId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    select(row) {
      this.$emit("get-select", row);
    },
    reviewAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要审核的数据");
        return;
      }
      this.$confirm("确认审核所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.DocId);
        this.$refs.list.reviewAll(ids);
      }).catch(() => { });
    },
    backAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要弃审的数据");
        return;
      }
      this.$confirm("确认弃审所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.DocId);
        this.$refs.list.backAll(ids);
      }).catch(() => { });
    },
  },
};
</script>
